  export default {
	"当前语言": "Ja",

	"公共.没有更多数据了": "これ以上のデータはありません",
	"公共.加载中": "読み込み中",
	"公共.下拉刷新": "下に引いて更新",
	"公共.释放刷新": "離して更新",
	"公共.链接钱包": "ウォレットに接続",

	"首页.轮播.标题": "現実世界の資産を信頼性・安全性・即時性を持ってチェーン上で流動させる",
	"首页.轮播.描述1": "現実世界の資産へ",
	"首页.轮播.描述2": "AI駆動のパフォーマンスパブリックチェーン",
	"首页.以太坊": "イーサリアム",
	"首页.企业绩效管理": "企業パフォーマンス管理",
	"首页.仲裁委员会": "仲裁委員会",
	"首页.探索DApps": "DAppsを探索",
	"首页.发现去中心化应用程序": "分散型アプリケーションを発見",
	"首页.查看所有Dapps": "すべてのDappsを表示",
	"首页.战略合作伙伴": "戦略的パートナー",
	"首页.值得信赖的生态系统合作伙伴": "信頼できるエコシステムパートナー",
	"首页.全部": "すべて",
	"首页.去中心化金融": "分散型金融",
	"首页.非同质化代币": "非代替性トークン",
	"首页.最新消息": "最新ニュース",
	"首页.保持对Web3关注": "Web3に注目し続ける",
	"首页.官方频道": "公式チャンネル",

	"首页.官方频道.推特.名称": "Twitter",
	"首页.官方频道.推特.描述": "@web3 プラットフォーム",
	"首页.官方频道.Discord.名称": "Discord",
	"首页.官方频道.Discord.描述": "@web3 プラットフォーム",
	"首页.官方频道.电报.名称": "Telegram",
	"首页.官方频道.电报.描述": "公式アップデート",
	"首页.官方频道.GitHub.名称": "GitHub",
	"首页.官方频道.GitHub.描述": "オープンソース",

	"首页.标签.Defi": "DeFi",
	"首页.标签.数据分析": "データ分析",
	"首页.标签.链游": "ブロックチェーンゲーム",
	"首页.标签.其他": "その他",
	"首页.标签.DEX": "DEX",

	"首页.合作伙伴.Solana.描述": "Solana は大規模採用のために設計されたブロックチェーンです。高速・コンポーザブル・グリーン・グローバルな分散化。",
	"首页.合作伙伴.CoinStats.描述": "ワンストップのトークン資産トラッカー。資産ポートフォリオを簡単かつ効率的に管理。",
	"首页.合作伙伴.Shaga.描述": "Shaga は革新的なゲーム体験の提供を目指しています。",
	"首页.合作伙伴.Grass.描述": "Grass で未使用のインターネット帯域幅を共有して報酬を獲得。",
	"首页.合作伙伴.Jupiter.描述": "暗号分野で最高の取引所を構築し、DeFi の巨頭を目指す。",
	"首页.合作伙伴.boop.fun.描述": "Meme コインコミュニティを構築し、BOOP をステーキングしてエアドロップ報酬を解放。",

	"闪兑.闪兑中心": "スワップセンター",
	"闪兑.闪兑": "スワップ",
	"闪兑.即时互换": "インスタント交換",
	"闪兑.快速兑换 · 实时到账 · 20:1比例": "高速両替 · リアルタイム着金 · 20:1レート",
	"闪兑.极速闪兑": "ライトニングスワップ",
	"闪兑.安全可靠": "安全で信頼性",
	"闪兑.RGT余额": "RGT残高",
	"闪兑.ROON余额": "ROON残高",
	"闪兑.可用于闪兑": "スワップ可能",
	"闪兑.闪兑获得": "スワップ獲得",
	"闪兑.节点等级": "ノードレベル",
	"闪兑.闪兑比例": "スワップレート",
	"闪兑.闪兑优惠": "スワップ割引",
	"闪兑.手续费": "手数料",
	"闪兑.闪兑数量": "スワップ数量",
	"闪兑.输入RGT数量": "RGT数量を入力",
	"闪兑.最低": "最低",
	"闪兑.余额": "残高",
	"闪兑.将获得": "獲得予定",
	"闪兑.立即闪兑": "今すぐスワップ",
	"闪兑.闪兑说明": "スワップ説明",
	"闪兑.极速到账": "超速入金",
	"闪兑.闪兑后ROON立即到账，无需等待": "スワップ後ROONは即座に入金、待機不要",
	"闪兑.安全保障": "安全保障",
	"闪兑.零手续费": "ゼロ手数料",
	"闪兑.享受零手续费特权": "ゼロ手数料特典を享受",
	"闪兑.闪兑成功": "スワップ成功",
	"闪兑.ROON已成功转入您的钱包": "ROONがウォレットに正常に転送されました",
	"闪兑.消耗RGT": "RGT消費",
	"闪兑.获得ROON": "ROON獲得",
	"闪兑.确认": "確認",

	"ROONMining.LP池": "LP池",
	"ROONMining.我的流动性": "マイ・リクイディティ",
	"ROONMining.我的LP数据": "マイLPデータ",
	"ROONMining.累计收益": "累計収益",
	"ROONMining.剩余天数": "残り日数",
	"ROONMining.天": "日",
	"ROONMining.推荐收益": "紹介収益",
	"ROONMining.总本金": "総元本",
	"ROONMining.添加LP": "LPを追加",
	"ROONMining.我的LP": "マイLP",
	"ROONMining.查看详情": "詳細を見る",
	"ROONMining.明细": "詳細",
	"ROONMining.提现": "出金",
	"ROONMining.更多功能": "その他機能",
	"ROONMining.推荐系统": "紹介システム",
	"ROONMining.直推10%收益": "直接紹介10%収益",
	"ROONMining.分红池": "配当プール",
	"ROONMining.多重收益分配": "マルチ収益配分",
	"ROONMining.NFT权益": "NFT権益",
	"ROONMining.节点与矿机": "ノードとマイニングマシン",
	"ROONMining.挖矿规则": "マイニングルール",
	"ROONMining.20天为一个周期,中间不可撤出LP": "20日を1サイクルとし、途中でLPを出金不可",
	"ROONMining.LP每个钱包地址最多添加一次LP": "各ウォレットアドレスはLPを最大1回追加可能",
	"ROONMining.每个LP每天收益1个ROON": "各LPは毎日1ROONを獲得",
	"ROONMining.20天到期:本金+20个ROON": "20日満了：元本+20ROON",
	"ROONMining.保障本金+利息,不受价格波动影响": "元本+利息を保障、価格変動の影響を受けない",

	"添加流动性.添加流动性": "リクイディティを追加",
	"添加流动性.重要提示": "重要な注意",
	"添加流动性.每个钱包地址仅可添加一次LP，20天锁定期内无法撤出，请谨慎操作": "各ウォレットアドレスは1回のみLP追加可能、20日間のロック期間中は出金不可のため、慎重に操作してください",
	"添加流动性.添加LP组合": "LPペアを追加",
	"添加流动性.数量": "数量",
	"添加流动性.余额": "残高",
	"添加流动性.请输入USDR数量": "USDR数量を入力してください",
	"添加流动性.最大": "最大",
	"添加流动性.请输入ROON数量": "ROON数量を入力してください",
	"添加流动性.LP组成比例为": "LP構成比率は",
	"添加流动性.挖矿规则": "マイニングルール",
	"添加流动性.锁走周期20天，期间无法撤出": "ロック期間20日間、期間中は出金不可",
	"添加流动性.每天固定收益1个ROON代币": "毎日固定で1ROONトークンを獲得",
	"添加流动性.保障本金安全，不受市场价格波动影响": "元本の安全性を保障、市場価格変動の影響を受けない",
	"添加流动性.每个钱包地址仅可添加一次LP": "各ウォレットアドレスは1回のみLP追加可能",
	"添加流动性.所有数据链上透明可查": "全データはチェーン上で透明性を持って確認可能",
	"添加流动性.确认添加LP": "LP追加を確認",
	"添加流动性.您即将添加": "以下を追加予定",
	"添加流动性.到流动性池": "リクイディティプールへ",
	"添加流动性.锁定期": "ロック期間",
	"添加流动性.天": "日",
	"添加流动性.预计收益": "予想収益",

	"我的LP.我的LP": "マイLP",
	"我的LP.添加流动性": "リクイディティを追加",
	"我的LP.进行中": "進行中",
	"我的LP.已完成": "完了",
	"我的LP.总价值": "総価値",
	"我的LP.剩余": "残り",
	"我的LP.天": "日",
	"我的LP.锁定中": "ロック中",
	"我的LP.移除LP": "LPを削除",
  "我的LP.已移除": "削除済み",
  "LP日志.日志明细": "ログ明細",
  "LP日志.确定复投LP": "LP再投を確認",
  "LP日志.确定复投": "再投を確認",
	"我的LP.确认移除LP": "LP削除を確認",
	"我的LP.您即将移除LP并获得以下资产": "LPを削除し、以下の資産を獲得します",
	"我的LP.本金返还": "元本返還",
	"我的LP.收益": "収益",
	"我的LP.总计": "合計",
	"我的LP.确认移除": "削除を確認",

	"持有LP数": "保有LP数",
	"我的LP": "マイLP",
	"暂无LP记录": "LP記録がありません",

	"推荐系统.推荐系统": "紹介システム",
	"推荐系统.我的团队": "マイチーム",
	"推荐系统.直推人数": "直接紹介人数",
	"推荐系统.团队总人数": "チーム総人数",
	"推荐系统.累计收益": "累計収益",
	"推荐系统.待领取收益": "受取待ち収益",
	"推荐系统.领取收益": "収益を受け取る",
	"推荐系统.我的推荐链接": "マイ紹介リンク",
	"推荐系统.复制连接": "リンクをコピー",
	"推荐系统.分享链接给好友，好友添加LP后您将获得其收益的10%作为推荐奖": "リンクを友達に共有、友達がLPを追加するとその収益の10%を紹介ボーナスとして獲得",
	"推荐系统.当前等级权益": "現在のランク権益",
	"推荐系统.个直推": "直接紹介",
	"推荐系统.推荐奖励": "紹介報酬",
	"推荐系统.当前等级": "現在のランク",
	"推荐系统.领取成功": "受取成功",
	"推荐系统.已成功领取": "正常に受け取りました",
	"推荐系统.复制": "コピー",
	"推荐系统.收益已发送到您的钱包地址": "収益がウォレットアドレスに送信されました",
	"推荐系统.上级地址": "上位アドレス",

	"分红池.分红池": "配当プール",
	"分红池.持有者": "保有者",
	"分红池.锁仓": "ロック",
	"分红池.FOMO": "FOMO",
	"分红池.保险": "保険",

	"分红池.LP持有者分红": "LP保有者配当",
	"分红池.分红奖池总额": "配当賞金プール総額",
	"分红池.我的LP": "マイLP",
	"分红池.持有者列表": "保有者リスト",
	"分红池.分红规则": "配当ルール",
	"分红池.盈利的25%自动分配给所有LP持有者": "利益の25%が全LP保有者に自動配分",
	"分红池.按照LP持有比例进行分红": "LP保有比率に基づいて配当",
	"分红池.每周自动发放到钱包地址": "毎週自動でウォレットアドレスに発送",
	"分红池.下次分红时间": "次回配当時間",

	"分红池.锁仓记录": "ロック記録",
	"分红池.查看所有ROON锁仓记录": "全ROONロック記録を表示",
	"分红池.开始日期": "開始日",
	"分红池.锁定中": "ロック中",
	"分红池.锁仓时长": "ロック期間",
	"分红池.已锁定": "ロック済み",
	"分红池.天": "日",
	"分红池.剩余时间": "残り時間",
	"分红池.已完成": "完了",
	"分红池.锁仓已完成，可领取": "ロックが完了し、受取可能",
	"分红池.锁仓说明": "ロック説明",
	"分红池.锁走期为1年，期间无法提取": "ロック期間は1年間、期間中は出金不可",
	"分红池.到期后获得本金+固定收益": "満了後に元本+固定収益を獲得",
	"分红池.收益来自盈利分配池": "収益は利益配分プールから",

	"分红池.FOMO池": "FOMOプール",
	"分红池.奖池总额": "賞金プール総額",
	"分红池.倒计时": "カウントダウン",
	"分红池.最后参与": "最終参加",
	"分红池.排行榜（前20名）": "ランキング（上位20名）",
	"分红池.奖励分配规则": "報酬配分ルール",
	"分红池.排名": "ランキング",
	"分红池.奖励": "報酬",
	"分红池.第": "第",
	"分红池.名": "名",
	"分红池.平分": "平等配分",
	"分红池.FOMO规则": "FOMOルール",
	"分红池.48小时内无新增参与则触发分配": "48時間以内に新規参加がない場合、配分がトリガー",
	"分红池.保险池每10天转入10%到FOMO池": "保険プールは10日ごとに10%をFOMOプールに移転",
	"分红池.前20名按排名获得奖励": "上位20名はランキングに基づいて報酬を獲得",

	"分红池.保险池总额": "保険プール総額",
	"分红池.待转入FOMO池": "FOMOプールへの移転待ち",
	"分红池.下次转入": "次回移転",
	"分红池.天后": "日後",
	"分红池.资金流向": "資金流向",
	"分红池.保险池": "保険プール",
	"分红池.盈利的25%进入保险池": "利益の25%が保険プールに入金",
	"分红池.每10天转入保险池的10%": "10日ごとに保険プールの10%を移転",
	"分红池.保险池作用": "保険プールの役割",
	"分红池.保障系统稳定运行": "システムの安定稼働を保障",
	"分红池.定期为FOMO池注入资金": "定期的にFOMOプールに資金を注入",
	"分红池.应对市场波动风险": "市場変動リスクに対応",


	"NFT权益.NFT权益": "NFT権益",
	"NFT权益.NFT权益系统": "NFT権益システム",
	"NFT权益.节点与矿机双重收益": "ノードとマイニングマシンの二重収益",
	"NFT权益.我的NFT": "マイNFT",
	"NFT权益.NFT收益": "NFT収益",
	"NFT权益.节点NFT": "ノードNFT",
	"NFT权益.矿机NFT": "マイニングマシンNFT",

	"NFT权益.超级节点": "スーパーノード",
	"NFT权益.专属权益": "専属権益",
	"NFT权益.20%额外收益": "20%追加収益",
	"NFT权益.优先提现权": "優先出金権",
	"NFT权益.治理投票权": "ガバナンス投票権",
	"NFT权益.专属客服": "専属カスタマーサービス",
	"NFT权益.价格": "価格",
	"NFT权益.总量": "総量",
	"NFT权益.剩余": "残り",
	"NFT权益.立即购买": "今すぐ購入",
	"NFT权益.已拥有": "所有済み",

	"NFT权益.钻石矿机": "ダイヤモンドマイニングマシン",
	"NFT权益.传说": "伝説",
	"NFT权益.算力": "ハッシュパワー",
	"NFT权益.日产出": "日間生産量",
	"NFT权益.史诗": "エピック",

	"NFT权益.累计收益": "累計収益",
	"NFT权益.查看详情": "詳細を見る",
	"NFT权益.NFT权益说明": "NFT権益説明",
	"NFT权益.节点NFT提供额外收益加成和治理权": "ノードNFTは追加収益ボーナスとガバナンス権を提供",
	"NFT权益.矿机NFT提供持续的挖矿产出": "マイニングマシンNFTは継続的なマイニング生産を提供",
	"NFT权益.所有NFT权益永久有效": "全NFT権益は永久に有効",


	"ROON锁仓.ROON锁仓": "ROONステーキング",
	"ROON锁仓.线性解锁": "線形ロック解除",
	"ROON锁仓.安全锁仓 · 线性解锁 · 随时提取": "安全なステーキング · 線形ロック解除 · いつでも引き出し",
	"ROON锁仓.安全锁仓": "安全なステーキング",
	"ROON锁仓.总锁仓全部": "総ステーキング全部",
	"ROON锁仓.解锁进度": "ロック解除進捗",
	"ROON锁仓.已解锁": "ロック解除済み",
	"ROON锁仓.解锁周期": "ロック解除サイクル",
	"ROON锁仓.周期": "サイクル",
	"ROON锁仓.可提取金额": "引き出し可能金額",
	"ROON锁仓.提取ROON": "ROONを引き出す",
	"ROON锁仓.输入提取数量": "引き出し数量を入力",
	"ROON锁仓.最低": "最低",
	"ROON锁仓.可提取": "引き出し可能",
	"ROON锁仓.立即提取": "今すぐ引き出す",
	"ROON锁仓.锁仓说明": "ステーキング説明",
	"ROON锁仓.ROON已成功转入您的钱包": "ROONがウォレットに正常に転送されました",
	"ROON锁仓.闪兑获得的ROON将按照固定周期线性": "スワップで獲得したROONは固定サイクルで線形的に",
	"ROON锁仓.随时提取": "いつでも引き出し",
	"ROON锁仓.安全保障": "安全保障",
	"ROON锁仓.智能合约锁仓，资金安全有保障": "スマートコントラクトステーキング、資金は安全に保障",
	"ROON锁仓.提取成功": "引き出し成功",
	"ROON锁仓.提取金额": "引き出し金額",
	"ROON锁仓.确认": "確認",
	"ROON锁仓.将提取到钱包": "ウォレットに引き出し",

	"USDR闪兑.USDR闪兑": "USDRスワップ",
	"USDR闪兑.闪兑": "スワップ",
	"USDR闪兑.余额": "残高",
	"USDR闪兑.提现": "出金",
	"USDR闪兑.极速闪兑": "超速スワップ",
	"USDR闪兑.快速兑换 · 安全可靠": "高速両替 · 安全で信頼性",
	"USDR闪兑.安全可靠": "安全で信頼性",
	"USDR闪兑.闪兑比例": "スワップレート",
	"USDR闪兑.实时汇率": "リアルタイム為替レート",
	"USDR闪兑.闪兑数量": "スワップ数量",
	"USDR闪兑.输入USDR数量": "USDR数量を入力",
	"USDR闪兑.将获得": "獲得予定",
	"USDR闪兑.立即闪兑": "今すぐスワップ",
	"USDR闪兑.闪兑记录": "スワップ記録",
	"USDR闪兑.提现记录": "出金記録",
	"USDR闪兑.兑换成功": "両替成功",
	"USDR闪兑.已完成": "完了しました",
	"USDR闪兑.处理中": "処理中",
	"USDR闪兑.消耗": "消費",
	"USDR闪兑.获得": "獲得",
	"USDR闪兑.提现金额": "出金金額",
	"USDR闪兑.提现地址": "出金アドレス",
	"USDR闪兑.可用余额": "利用可能残高",
	"USDR闪兑.提现数量": "出金数量",
	"USDR闪兑.请输入数量": "数量を入力してください",
	"USDR闪兑.输入钱包地址": "ウォレットアドレスを入力",
	"USDR闪兑.确认": "確認",
	
	"质押.质押中": "ステーキング中",
	"质押.收益": "収益",
	"质押.ROON锁仓": "ROONステーキング",
	"质押.天": "日",
	"质押.年化收益率": "年利回り",
	"质押.最低": "最低",
	"质押.质押金额": "ステーキング金額",
	"质押.输入质押金额": "ステーキング金額を入力",
	"质押.最大": "最大",
	"质押.余额": "残高",
	"质押.立即质押": "今すぐステーキング",
	"质押.我的质押": "マイステーキング",
	"质押.查看全部质押": "全ステーキングを表示",
	"质押.进行中": "進行中",
	"质押.天锁定": "日ロック",
	"质押.年百分率": "年百分率",
	"质押.质押进度": "ステーキング進捗",
	"质押.剩余": "残り",
	"质押.累计收益": "累計収益",
	"质押.详情": "詳細",
	
	"销毁挖矿.销毁挖矿": "破棄 майнинг",
	"销毁挖矿.实时销毁数据": "リアルタイム破棄データ",
	"销毁挖矿.全网销毁": "全ネットワーク破棄",
	"销毁挖矿.我的销毁": "マイ破棄",
	"销毁挖矿.占比": "占有率",
	"销毁挖矿.分享收益": "収益分配",
	"销毁挖矿.提现": "出金",
	"销毁挖矿.明细": "詳細",
	"销毁挖矿.已销毁": "破棄済み",
	"销毁挖矿.锁仓中": "ロック中",
	"销毁挖矿.今日可领": "本日受取可能",
	"销毁挖矿.开始销毁": "破棄開始",
	"销毁挖矿.销毁记录": "破棄記録",
	"销毁挖矿.选择销毁档位": "破棄価格帯を選択",
	"销毁挖矿.个档位可选": "価格帯が選択可能",
	"销毁挖矿.天": "日",
	"销毁挖矿.确认销毁": "破棄を確認",
	"销毁挖矿.销毁挖矿": "破棄 майнинг",
	"销毁挖矿.团队": "チーム",
	"销毁挖矿.释放进度": "リリース進捗",
	"销毁挖矿.总收益": "総収益",
	"销毁挖矿.每日释放": "日間リリース",
	"销毁挖矿.已到账": "着金済み",
	"销毁挖矿.待释放": "リリース待ち",
	"销毁挖矿.自动释放中": "自動リリース中",
	
	"销毁我的团队.我的团队": "マイチーム",
	"销毁我的团队.邀请好友": "友達を招待",
	"销毁我的团队.团队列表": "チームリスト",
	"销毁我的团队.直推人数": "直接紹介人数",
	"销毁我的团队.直推收益": "直接紹介収益",
	"销毁我的团队.我的邀请码": "マイ招待コード",
	"销毁我的团队.复制": "コピー",
	"销毁我的团队.我的邀请码": "マイ招待コード",
	"销毁我的团队.复制链接": "リンクをコピー",
	"销毁我的团队.分享链接": "リンクを共有",
	"销毁我的团队.邀请规则": "招待ルール",
	"销毁我的团队.直推好友销毁可获得5%奖励": "直接紹介友達の破棄により5%報酬を獲得",
	"销毁我的团队.团队等级越高，极差收益越多": "チーム等級が高いほど、極差収益が多い",
	"销毁我的团队.NFT节点极差:1%-5%": "NFTノード極差:1%-5%",
	"销毁我的团队.矿机领航者极差:1%-5%": "マイニングマシンリーダー極差:1%-5%",
	"销毁我的团队.流动性挖矿极差:R1-R10(1%-10%)": "流動性 майнинг極差:R1-R10(1%-10%)",
	"销毁我的团队.质押NFT解锁团队奖励": "NFTステーキングでチーム報酬をアンロック",
	"销毁我的团队.质押NFT后可获得团队极差奖励(1%-5%)，享受更多收益": "NFTステーキング後、チーム極差報酬(1%-5%)を獲得し、より多くの収益を享受",
	"销毁我的团队.立即质押NFT": "今すぐNFTステーキング",
	"销毁我的团队.我的等级": "マイ等級",
	"销毁我的团队.极差": "極差",
	"销毁我的团队.领航者": "リーダー",
	"销毁我的团队.直推收益": "直接紹介収益",
	"销毁我的团队.团队收益": "チーム収益",
	"销毁我的团队.直推人数": "直接紹介人数",
	"销毁我的团队.团队总人数": "チーム総人数",
	"销毁我的团队.团队销毁量": "チーム破棄量",
	"销毁我的团队.直推成员": "直接紹介メンバー",
	"销毁我的团队.共": "合計",
	"销毁我的团队.人": "人",
	"销毁我的团队.销毁量": "破棄量",
	"销毁我的团队.等级说明": "等級説明",
	"销毁我的团队.R1-R10:流动性挖矿等级，极差1%-10%": "R1-R10:流動性 майнинг等級、極差1%-10%",
	"销毁我的团队.NFT节点:质押NFT获得，极差1%-5%": "NFTノード:NFTステーキング獲得、極差1%-5%",
	"销毁我的团队.矿机领航者:团队销毁达标，极差1%-5%": "マイニングマシンリーダー:チーム破棄基準達成、極差1%-5%",
	"销毁我的团队.等级越高，团队收益越多": "等級が高いほど、チーム収益が多い",
	"销毁我的团队.质押NFT": "NFTステーキング",
	"销毁我的团队.质押NFT后将解锁团队极差奖励功能，享受1%-5%的团队收益分成": "NFTステーキング後、チーム極差報酬機能をアンロックし、1%-5%のチーム収益分成を享受",
	"销毁我的团队.NFT数量": "NFT数量",
	"销毁我的团队.个": "個",
	"销毁我的团队.质押周期": "ステーキング期間",
	"销毁我的团队.永久": "永久",
	"销毁我的团队.团队极差": "チーム極差",
	"销毁我的团队.确认质押": "ステーキングを確認",
	
	
	"NUT.菜单.首页": "ホーム",
	"NUT.菜单.奖励": "報酬",
	"NUT.菜单.介绍": "紹介",
	"NUT.菜单.奖励池": "報酬プール",
	
	"NUT.首页.活跃": "アクティブ",
	"NUT.首页.下一代DeFi生态代币": "次世代DeFi生態トークン",
	"NUT.首页.燃烧池": "バーンプール",
	"NUT.首页.稳定池": "安定プール",
	"NUT.首页.托底池": "底上げプール",
	"NUT.首页.LP奖励": "LP報酬",
	"NUT.首页.参与质押": "ステーキング参加",
	"NUT.首页.参与激励": "参加インセンティブ",
	"NUT.首页.我的参与统计": "マイ参加統計",
	"NUT.首页.总参与": "総参加",
	"NUT.首页.份数": "口数",
	"NUT.首页.预计收益": "予想収益",
	"NUT.首页.参与数量": "参加数量",
	"NUT.首页.余额": "残高",
	"NUT.首页.最大": "最大",
	"NUT.首页.份": "口",
	"NUT.首页.参与规则说明": "参加ルール説明",
	"NUT.首页.1,000 ROON =1份，可多次参与": "1,000 ROON =1口、複数回参加可能",
	"NUT.首页.35%全网分红ROON": "35%全ネットワーク配当ROON",
	"NUT.首页.65%自动组LP锁定999年": "65%自動組LPロック999年",
	"NUT.首页.全链上执行，透明可查": "全チェーン実行、透明性確認可能",
	"NUT.首页.收益分配": "収益分配",
	"NUT.首页.全网分红": "全ネットワーク配当",
	"NUT.首页.组LP锁定": "組LPロック",
	"NUT.首页.65 ROON中:32.5买入NUT + 32.5 ROON组LP": "65 ROON中:32.5購入NUT + 32.5 ROON組LP",
	"NUT.首页.最少": "最少",
	
	"NUT.奖励.我的奖励总览": "マイ報酬総覧",
	"NUT.奖励.可领取奖励": "受取可能報酬",
	"NUT.奖励.已领取总额": "受取済み総額",
	"NUT.奖励.税收分红": "税收配当",
	"NUT.奖励.持币分红": "保有配当",
	"NUT.奖励.LP奖励": "LP報酬",
	"NUT.奖励.NFT分红": "NFT配当",
	"NUT.奖励.税收分红领取": "税收配当受取",
	"NUT.奖励.盈利税+砸盘税": "利益税+暴落税",
	"NUT.奖励.盈利税分红": "利益税配当",
	"NUT.奖励.回购": "買い戻し",
	"NUT.奖励.砸盘税分红": "暴落税配当",
	"NUT.奖励.总可领取": "総受取可能",
	"NUT.奖励.领取时50%销毁，50%到账": "受取時50%破棄、50%入金",
	"NUT.奖励.税收机制说明": "税收メカニズム説明",
	"NUT.奖励.盈利税20%:回购ROON分红给参与者": "利益税20%: ROON買い戻し参加者に配当",
	"NUT.奖励.盘税25%:每日8点AVE价格为准，跌1%扣2%": "暴落税25%: 毎日8時AVE価格基準、1%下落時2%控除",
	"NUT.奖励.最高下跌12.5%时税率达25%": "最大下落12.5%時税率25%達成",
	"NUT.奖励.领取税收分红": "税收配当受取",
	"NUT.奖励.持币分红": "保有配当",
	"NUT.奖励.手续费": "手数料",
	"NUT.奖励.可领取": "受取可能",
	"NUT.奖励.下次分红": "次回配当",
	"NUT.奖励.已领取": "受取済み",
	"NUT.奖励.参与条件": "参加条件",
	"NUT.奖励.持有": "保有",
	"NUT.奖励.领取费用": "受取手数料",
	"NUT.奖励.价值": "価値",
	"NUT.奖励.领取时50%销毁，50%到账": "受取時50%破棄、50%入金",
	"NUT.奖励.领取奖励": "報酬受取",
	
	"NUT.奖励.LP贡献奖励": "LPコントリビューション報酬",
	"NUT.奖励.我的流动性": "マイ流動性",
	"NUT.奖励.池份额": "プールシェア",
	"NUT.奖励.LP每小时自动撤出0.25%，0.125%燃烧，0.125%分红": "LP每小时自動引出0.25%、0.125%燃却、0.125%配当",
	"NUT.奖励.添加流动性": "流動性追加",
	"NUT.奖励.流动性池": "流動性プール",
	"NUT.奖励.当前池子比例": "現在プール比率",
	"NUT.奖励.数量": "数量",
	"NUT.奖励.余额": "残高",
	"NUT.奖励.请输入NUT数量": "NUT数量を入力してください",
	"NUT.奖励.请输入ROON数量": "ROON数量を入力してください",
	"NUT.奖励.最大": "最大",
	"NUT.奖励.花店容差": "スリッページ許容度",
	"NUT.奖励.自定义": "カスタム",
	"NUT.奖励.取消": "キャンセル",
	"NUT.奖励.确认添加": "追加を確認",
	
	"NUT.奖励.NFT资产分红": "NFT資産配当",
	"NUT.奖励.盈利税": "利益税",
	"NUT.奖励.节点NFT": "ノードNFT",
	"NUT.奖励.白名单NFT": "ホワイトリストNFT",
	"NUT.奖励.持有": "保有",
	"NUT.奖励.个": "個",
	"NUT.奖励.NFT分红规则": "NFT配当ルール",
	"NUT.奖励.节点NFT:50%分红(权重值分配)": "ノードNFT:50%配当(重み値配分)",
	"NUT.奖励.白名单NFT:50%分红(加权平均)": "ホワイトリストNFT:50%配当(加重平均)",
	"NUT.奖励.激活条件: 持币≥100.000 NUT": "活性条件: 保有≥100.000 NUT",
	"NUT.奖励.领取时50%销毁，50%到账": "受取時50%破棄、50%入金",
	"NUT.奖励.领取全部NFT奖励": "すべてのNFT報酬受取",
	
	"NUT.介绍.NUT 代币": "NUT トークン",
	"NUT.介绍.创新的Defi生态系统，多重分红机制": "革新的なDeFiエコシステム、複数配当メカニズム",
	"NUT.介绍.代币信息": "トークン情報",
	"NUT.介绍.代币名称": "トークン名",
	"NUT.介绍.NUT 代币": "NUT トークン",
	"NUT.介绍.代币符号": "トークン記号",
	"NUT.介绍.总供应量": "総供給量",
	"NUT.介绍.一千万亿": "1000京",
	"NUT.介绍.稳定比": "安定比率",
	"NUT.介绍.美元兑日元": "USD/JPY",
	"NUT.介绍.奖励代币": "報酬トークン",
	"NUT.介绍.三大资金池": "三大資金プール",
	"NUT.介绍.燃烧池": "バーンプール",
	"NUT.介绍.NUT/ROON 取引対、継続的バーン通縮": "NUT/ROON 取引対、継続的バーン通縮",
	"NUT.介绍.稳定池": "安定プール",
	"NUT.介绍.NUT/USDR 取引対、価格安定支": "NUT/USDR 取引対、価格安定支",
	"NUT.介绍.拖底池": "底上げプール",
	"NUT.介绍.ROON 转账即交易，X314协议，隐藏性拖底": "ROON 送金は即座に取引、X314プロトコル、隠された底上げ",
	"NUT.介绍.取引手数料配分": "取引手数料配分",
	"NUT.介绍.回流底池燃烧": "回流底プール燃却",
	"NUT.介绍.回流ROON LP池": "回流ROON LPプール",
	"NUT.介绍.价格拖底": "価格底上げ",
	"NUT.介绍.生態構築": "生態構築",
	"NUT.介绍.持币分红": "保有配当",
	"NUT.介绍.回购销毁": "買い戻し破棄",
	"NUT.介绍.LP池机制": "LPプールメカニズム",
	"NUT.介绍.LP每小时自动撤出0.25%": "LP每小时自動引出0.25%",
	"NUT.介绍.其中0.125%自动燃烧销毁": "そのうち0.125%自動燃却破棄",
	"NUT.介绍.另外0.125%分红给LP提供者": "さらに0.125% LP提供者に配当",
	"NUT.介绍.1%手数料リアルタイム配当": "1%手数料リアルタイム配当LPユーザー",
	"NUT.介绍.参与质押机制": "ステーキング参加メカニズム",
	"NUT.介绍.向合约地址打入ROON代币100": " контракт地址にROONトークン100を送金",
	"NUT.介绍.ROON=1份，可多次参与": "ROON=1口とし、複数回参加可能",
	"NUT.介绍.全链上执行，透明可查": "チェーン全体で実行、透明的で閲覧可能",
	"NUT.介绍.收益分配": "利益分配",
	"NUT.介绍.35%全网分红ROON": "35%ネットワーク全体の配当ROON",
	"NUT.介绍.65%自动组LP锁定999年": "65%自動LP組んで999年間ロック",
	"NUT.介绍.65 ROON中:32.5买入NUT + 32.5 ROON组LP": "65 ROON中:32.5 NUT購入 + 32.5 ROONでLP組成",
	"NUT.介绍.税收机制": "税制メカニズム",
	"NUT.介绍.盈利税（20%）": "利益税（20%）",
	"NUT.介绍.20%回购ROON分给参与者": "20% ROON買い戻し参加者に分配",
	"NUT.介绍.其中10%分红给LP用户": "そのうち10%はLPユーザーに配当",
	"NUT.介绍.5%的利润将分给NFT资产持有者": "5%の利益はNFT資產保有者に分配",
	"NUT.介绍.5%用于市值管理": "5%は時価総額管理に使用",
	"NUT.介绍.砸盘税 (最高25%)": "暴落税（最大25%）",
	"NUT.介绍.每天早上8点AVE价格为准": "毎日午前8時のAVE价格为基準",
	"NUT.介绍.跌1%扣2%手续费": "1%下落ごとに2%手数料控除",
	"NUT.介绍.最高下跌12.5%时税率达25%": "最大12.5%下落時に税率25%に達する",
	"NUT.介绍.25% 回购ROON分给参与者": "25% ROON買い戻し参加者全員に分配",
	"NUT.介绍.持币分红": "トークン保有配当",
	"NUT.介绍.0.5%手续费用于持币分红ROON": "0.5%手数料でトークン保有配当ROON",
	"NUT.介绍.单地址持币>100,000 NUT可参与": "単一アドレス保有>100,000 NUTで参加可能",
	"NUT.介绍.前台手动领取，支付50% NUT价值": "フロントエンド手動受取、50% NUT価値支払い",
	"NUT.介绍.领取时50%销毁，50%到账": "受取時50%破棄、50%アカウントに着金",
	"NUT.介绍.NFT分红机制": "NFT配当メカニズム",
	"NUT.介绍.节点NFT(50%)": "ノードNFT(50%)",
	"NUT.介绍.权重值分配分红": "重み値による配当分配",
	"NUT.介绍.持币≥100.000 NUT激活": "トークン保有≥100.000 NUTでアクティブ化",
	"NUT.介绍.白名单NFT(50%)": "ホワイトリストNFT(50%)",
	"NUT.介绍.加权平均分配分红": "加重平均による配当分配",
	"NUT.介绍.持币≥100.000 NUT激活": "トークン保有≥100.000 NUTでアクティブ化",
	"NUT.介绍.重要提示": "重要なヒント",
	"NUT.介绍.所有盈利税和砸盘税分红ROON": "すべての利益税と暴落税配当ROON",
	"NUT.介绍.领取时50%打入黑洞销毁，50%到用户钱包": "受取時50%ブラックホールに破棄、50%ユーザーズウォレットへ",
	"NUT.介绍.全链上执行，透明可查": "チェーン全体で実行、透明的で閲覧可能",
	"NUT.介绍.智能合约自动执行，无需人工干预": "スマートコントラクト自動実行、人的介入不要",
	
	"NUT.奖励池.资金池总览": "資金プール概要",
	"NUT.奖励池.实时监控三大资金池运作状态": "3大資金プール動作状態をリアルタイム監視",
	"NUT.奖励池.资金池总价值": "資金プール総価値",
	"NUT.奖励池.24小时注入": "24時間注入",
	"NUT.奖励池.24小时分配": "24時間分配",
	"NUT.奖励池.24小时销毁": "24時間破棄",
	"NUT.奖励池.LP池": "LPプール",
	"NUT.奖励池.质押池": "ステーキングプール",
	"NUT.奖励池.税收池": "税プール",
	"NUT.奖励池.LP池流动性池": "LPプール流動性プール",
	"NUT.奖励池.运行中": "運転中",
	"NUT.奖励池.交易手续费的35%注入LP池，增强流动性": "取引手数料の35%をLPプールに注入、流動性向上",
	"NUT.奖励池.池子总价值": "プール総価値",
	"NUT.奖励池.今日注入": "本日注入",
	"NUT.奖励池.累计分配": "累計分配",
	"NUT.奖励池.累计注入": "累計注入",
	"NUT.奖励池.查看详细数据": "詳細データを見る",
	"NUT.奖励池.操作记录": "操作記録",
	"NUT.奖励池.查看全部": "すべて見る",
	"NUT.奖励池.注入": "注入",
	"NUT.奖励池.加载更多": "さらに読み込む",
	
	"NUT.奖励池.LP流动性池": "LP流動性プール",
	"NUT.奖励池.详细数据分析": "詳細データ分析",
	"NUT.奖励池.概览": "概要",
	"NUT.奖励池.图表": "チャート",
	"NUT.奖励池.记录": "記録",
	"NUT.奖励池.占比": "割合",
	"NUT.奖励池.数量": "数量",
	"NUT.奖励池.LP代币": "LPトークン",
	"NUT.奖励池.持有人数": "保有者数",
	"NUT.奖励池.年华收益": "年間利回り",
	"NUT.奖励池.日奖励": "日次報酬",
	"NUT.奖励池.7日资金流动趋势": "7日間資金流動トレンド",
	"NUT.奖励池.资金分配占比": "資金分配割合",
	"NUT.奖励池.回购": "買い戻し",
	"NUT.奖励池.销毁": "破棄",
	"NUT.奖励池.分配": "分配",
	
	"NUT.奖励池.质押奖励池": "ステーキング報酬プール",
	"NUT.奖励池.交易手续费的25%用于质押奖励分配": "取引手数料の25%をステーキング報酬分配に使用",
	"NUT.奖励池.总质押量": "総ステーク量",
	"NUT.奖励池.质押人数": "ステーク者数",
	"NUT.奖励池.平均质押": "平均ステーク",
	"NUT.奖励池.待领奖励": "未受取報酬",
	"NUT.奖励池.待领奖励": "未受取報酬",
	
	"NUT.奖励池.税收回购池": "税買い戻しプール",
	"NUT.奖励池.交易手续费的40%用于税收回购和销毁": "取引手数料の40%を税買い戻しと破棄に使用",
	"NUT.奖励池.今日回购": "本日買い戻し",
	"NUT.奖励池.累计销毁": "累計破棄",
	"NUT.奖励池.盈利税": "利益税",
	"NUT.奖励池.砸盘税": "暴落税",
	"NUT.奖励池.回购总额": "総額買い戻し",
	"NUT.奖励池.销毁总额": "総額破棄",
	"NUT.奖励池.分配总额": "総額分配",
	"NUT.奖励池.日回购": "日次買い戻し",

	"弹窗.复制成功": "コピーしました",
	"弹窗.复制失败": "コピーに失敗",
	"弹窗.確認": "確認",
	"弹窗.取消": "キャンセル",
	"弹窗.上级邀请码": "上位の招待コード",
	"弹窗.知道了": "了解しました",
	"弹窗.请输入邀请码": "招待コードを入力してください",

	"吐司.敬请期待": "近日公開",
	"吐司.操作成功": "操作が成功しました",
	"吐司.操作失败": "操作に失敗しました",
	"吐司.请在钱包中打包": "ウォレットで確認してください",
	"吐司.暂未开放": "まだ開放されていません",
	"吐司.用户拒绝提供程序访问": "ユーザーがアプリのアクセスを拒否しました",
	"吐司.请刷新重试": "更新して再試行してください",
	"吐司.请输入邀请码": "招待コードを入力してください",
	"吐司.操作成功请稍后刷新查看": "操作が成功しました。しばらくして更新してご確認ください",
	"吐司.添加流动性成功": "流動性の追加に成功しました",
	"吐司.余额不足": "残高が不足しています",
	"吐司.收款地址无效": "受取アドレスが無効です",

	"解押NFT": "NFTを解除する",
	"质押NFT": "NFTをステイクする",
	"选择NFT解押": "解除するNFTを選択",
	"选择NFT质押": "ステイクするNFTを選択",
	"当前节点等级:黄金": "現在のノードレベル：ゴールド",
	"jiemiao": "Level3のNFTのみ解除可能",
	"zhimiao": "Level3のNFTのみステイク可能",
	"已选择": "選択済み",
	"黄金": "ゴールド",
	"解押": "解除",
	"质押": "ステイク",
	"个": "個",

	"添加流动性": "流動性追加",
	"交换代币": "トークンスワップ",
	"从": "から",
	"余额": "残高",
	"请输入": "入力してください",
	"至": "まで",
	"池股份": "プールシェア",
	"当前年利率": "現在年利回り",
	"代币": "トークン",
	"美元稳定币": "イーサリアム-USDステイブルコイン",
	"热门池": "人気プール",
	"兑换美元稳定币兑换": "USDステイブルコイン交換",
	"以太坊": "イーサリアム (ETH)",
	"亿美元": "億ドル",
	"四月": "4月",
	"我的流动池": "マイ流動性プール",
	"总计": "合計",
	"我的稳定币": "マイステイブルコイン",
	"小时交易量": "時間当たり取引量",
	"百万": "百万",
	"移除": "削除",
	"添加更多": "さらに追加",
	"总薪酬": "総報酬",
	"池": "プール",
	"交易池": "取引プール",
	"领取所有奖励": "すべての報酬を受け取る",
	"移除流动性": "流動性削除",
	"确定要移除": "プールの流動性",
	"我的流动性": "マイ流動性",
	"预计收益": "予想収益",
	"取消": "キャンセル",
	"确认移除": "削除確認",
	"跨链桥": "クロスチェーンブリッジ",
	"预计到账时间": "予想到金時間",
	"分钟到账": "数分で到金",
	"安全级别": "セキュリティレベル",
	"高": "高",
	"手续费": "手数料",
	"美元": "ドル (USD)",
	"多边形": "ポリゴン (MATIC)",
	"代币数量": "トークン数量",
	"": "USDステイブルコイン",
	"接收地址": "受け取りアドレス",
	"分钟": "分",
	"桥接手续费": "ブリッジ手数料",
	"目标链手续费": "目標チェーン手数料",
	"总手续费": "総手数料",
	"开始跨链": "クロスチェーン開始",
	"最近跨链记录": "直近クロスチェーン記録",
	"分钟前": "分前",
	"待处理": "処理待ち",
	"完成": "完了",
	"支持的网络": "サポートネットワーク",
	"企业绩效管理": "企業パフォーマンス管理 (EPM)",
	"选择币种": "通貨選択",
	"滑点容差": "スリッページ許容度",
	"费率": "レート",
	"滑动": "スライド",
	"百分比": "パーセンテージ",
	"网络费用": "ネットワーク手数料",
	"最近的交换": "直近スワップ",
	"我的池": "私流動性プール",
	'使用我的地址':'私のアドレスを使用',
    "我的LP.暂无数据": "データなし",
    "我的LP.复投": "再投資",
  }
